module.exports = __webpack_public_path__ + "img/icono.68c77618.png";